<template>
  <section class="checkout-section">
    <header class="checkout-section__header">
      <h2 class="checkout-section__header__title">
        <slot name="header"></slot>
      </h2>
    </header>
    <div class="checkout-section__body">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ['cssClass']
}
</script>
